var exports = {
  "k": "xa15a2ab7--f6b807--container",
  "K": "xa15a2ab7--f6b807--icon",
};

module.exports = exports;
